import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import './style/fonts.scss'
import './plugins/eslintrc'
import './style/css-global.scss'
import * as moment from "moment";

Vue.prototype.$moment = moment;
// Vue.use(require('vue-moment'));
Vue.config.productionTip = false;


new Vue({
  vuetify,
  router,
  store,

  render: h => h(App),
}).$mount('#app');
